import React from 'react';

const AudienceIcon = (): React.ReactElement => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 62 62"
      width={32}
      height={32}
    >
      <path
        fill="#B3DABD"
        d="M28 50.667H4S2.667 33.333 20 33.333c8 0 10.667 5.778 10.667 5.778A23.602 23.602 0 0 0 28 50.667z"
      />
      <path
        fill="#9D9D9D"
        d="M61.076 50.667H35.232a16.873 16.873 0 0 0-3.232-12s1.796-6.665 11.846-6.665c0 0 17.23-1.436 17.23 18.665z"
      />
      <path
        stroke="#404040"
        strokeMiterlimit="10"
        strokeWidth="1.5"
        d="M44.61 27.588a7.794 7.794 0 1 0 0-15.588 7.794 7.794 0 0 0 0 15.588zM10.843 21.088a7.83 7.83 0 1 1 7.83 7.829 7.876 7.876 0 0 1-7.83-7.83v0z"
      />
      <path
        stroke="#404040"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M3.744 50.556v-2.102a15.549 15.549 0 0 1 15.832-15.25v0a15.549 15.549 0 0 1 15.831 15.25v.13a3.33 3.33 0 0 1-3.389 3.265v0a3.329 3.329 0 0 1-3.389-3.264v-1.636a15.677 15.677 0 0 1 15.962-15.376v0A15.677 15.677 0 0 1 60.553 46.95v3.225"
      />
    </svg>
  );
};

export default AudienceIcon;
